import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function login() {
  const redirectUrl = window.location.href; // come back here after auth
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  useEffect(() => {
    if (loading || !user || !token) return;
    setStatus("processing");
    api.acceptInvite(token)
      .then(() => {
        setStatus("success");
        setTimeout(() => navigate("/dashboard"), 1500);
      })
      .catch((e) => {
        setStatus("error");
        setError(e.response?.data?.detail || "Invite invalid or already used");
      });
  }, [user, loading, token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="accept-invite-page">
      <div className="max-w-md p-8 border-2 border-black brutal-shadow-lg">
        <div className="text-eyebrow mb-3">Workspace invite</div>
        <h1 className="font-display font-black text-4xl tracking-tighter mb-4">Join the workspace</h1>
        {!user && !loading && (
          <>
            <p className="text-sm text-[#52525B] mb-6">Sign in to accept your invite. We'll bring you right back here.</p>
            <button onClick={login} data-testid="invite-signin-button" className="bg-[#0A0A0B] text-white px-5 py-3 text-sm hover:bg-[#002FA7]">Sign in with Google</button>
          </>
        )}
        {status === "processing" && <p className="text-sm">Joining…</p>}
        {status === "success" && <p className="text-sm text-[#059669]">Joined! Redirecting…</p>}
        {status === "error" && (
          <>
            <p className="text-sm text-[#E11D48]">{error}</p>
            <Link to="/dashboard" className="mt-4 inline-block text-eyebrow text-[#002FA7]">Go to dashboard</Link>
          </>
        )}
      </div>
    </div>
  );
}
